import { CampaignsTemplatesSelectProps } from '../types';
import { CampaignsRowContainer, StyledBasicSelect, StyledSelectOptionsContainer } from '../styles';
import { parseMessageTypes, parseEmailSenders, parseSmsSenders } from '../utils';
import { CampaignTooltip } from '../CampaignTooltip';
import {
  CAMPAIGN_TEMPLATE_SELECTS,
  CAMPAIGN_TABLE_ROWS_ID,
  CAMPAIGN_ID_TEST_ID,
  CAMPAIGN_NAME_TEST_ID,
  MESSAGE_TYPE_TEST_ID,
  SENDER_TEST_ID,
} from '../constants';

export const CampaignsTemplatesSelect = ({
  campaignId,
  campaignName,
  senders,
  messageTypes,
  optionsLoading,
  messageMedium,
  isMediumSMS,
  isMediumEmail,
}: CampaignsTemplatesSelectProps) => {
  const hasSenders = senders?.length > 0;
  const hasMessageTypes = messageTypes?.length > 0;
  const messageTypeField = isMediumEmail || isMediumSMS ? messageMedium : '';

  return (
    <CampaignsRowContainer data-test={CAMPAIGN_TABLE_ROWS_ID} $isCloneable>
      <CampaignTooltip maxWidth={65} text={campaignId} id={CAMPAIGN_ID_TEST_ID} />
      <CampaignTooltip maxWidth={325} text={campaignName} id={CAMPAIGN_NAME_TEST_ID} />
      <StyledBasicSelect
        id={MESSAGE_TYPE_TEST_ID}
        data-test={MESSAGE_TYPE_TEST_ID}
        name={`${campaignId}.messageTypeId${messageTypeField}`}
        placeholder={CAMPAIGN_TEMPLATE_SELECTS?.messageType?.placeholder}
        options={parseMessageTypes(messageTypes)}
        isDisabled={!hasMessageTypes}
        isLoading={optionsLoading}
        SelectOptionsContainer={StyledSelectOptionsContainer}
      />
      {(isMediumSMS || isMediumEmail) && (
        <StyledBasicSelect
          id={`${messageMedium?.toLowerCase()}-${SENDER_TEST_ID}`}
          data-test={`${messageMedium?.toLowerCase()}-${SENDER_TEST_ID}`}
          name={`${campaignId}.sender${messageMedium}`}
          placeholder={CAMPAIGN_TEMPLATE_SELECTS?.sender?.placeholder}
          options={isMediumEmail ? parseEmailSenders(senders) : parseSmsSenders(senders)}
          isDisabled={!hasSenders}
          isLoading={optionsLoading}
          SelectOptionsContainer={StyledSelectOptionsContainer}
        />
      )}
    </CampaignsRowContainer>
  );
};
